'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _ChatHeadingConfigTypes = require('../constants/ChatHeadingConfigTypes');

exports.default = (0, _immutable.Record)({
  '@type': _ChatHeadingConfigTypes.COMPANY,
  companyLogoUrl: '',
  customChatName: ''
}, 'CompanyChatHeadingConfig');
module.exports = exports['default'];